import { RouterModule, Routes } from "@angular/router";
import { OtpVerificationComponent } from "./otpverification.component";
import { CommonModule } from "@angular/common";
import { MatchHeightModule } from "app/shared/directives/match-height.directive";
import { NgModule } from "@angular/core";
import { MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule } from "@angular/material";
import { ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SharedModule } from "app/shared/shared.module";
import { NgOtpInputModule } from "ng-otp-input";
import { RecaptchaModule } from "ng-recaptcha";


const routes: Routes = [
    {
        path: '',
        component: OtpVerificationComponent,
        data: {
            title: 'OTP Verification'
        }
    }
];
@NgModule({
    declarations: [
        OtpVerificationComponent,
    ],
    imports: [
        CommonModule,
        NgbModule,
        MatchHeightModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        SharedModule,
        MatButtonModule,
        ReactiveFormsModule,
        RecaptchaModule,
        NgOtpInputModule,
        RouterModule.forChild(routes)
    ],

    providers: [],
    exports: [OtpVerificationComponent]

})
export class OtpVerificationModule { }
